import { dbg } from '../debug/debugLog.js';

/** Observe a slow write without claiming that an uncancelled operation failed. */
export async function withMutationWatchdog<T>(label: string, op: () => Promise<T>): Promise<T> {
  const timer = setTimeout(() => {
    dbg.warn('local-mutation', 'still_pending', { label, threshold_ms: 15_000 });
  }, 15_000);
  try {
    return await op();
  } finally {
    clearTimeout(timer);
  }
}
